module.exports = __webpack_public_path__ + "images/marketing/peeps/shannon_shimabukuro.jpg";